import React from 'react';
import { Link } from 'react-router-dom';

const Reminders: React.FC = () => (
  <section className="container section animate-fadeInUp">
    <h2>Boost repeat business with automated reminders</h2>
    <p style={{ fontSize: '1rem', marginBottom: '1.5rem' }}>
      Sparki automatically monitors customers’ vehicles and sends timely MOT & service reminders,
      driving repeat bookings and customer loyalty.
    </p>
    <ul className="features-grid">
      <li>📩 Automatic notifications & email reminders</li>
      <li>🚗 Easy vehicle details & history access</li>
      <li>⚡ Reduced admin, improved efficiency</li>
    </ul>
    <div className="section-cta">
          <Link to="/get-started" className="cta">Get started for free</Link>
        </div>
  </section>
);

export default Reminders;
